import { useBillingContextQuery } from '@/hooks/queries/use-billing-context-query';
import { usePaywall } from '@/hooks/use-paywall';
import type { PaywallType } from '@/libs/paywall-url-state';
import { useUpgradeModalStore } from '@/stores/upgrade-modal-store';
import { PlanTier, upgradeTierFor, type PlanLimitReachedData } from '@fluenceur/types';
import { PlanChoicePanel } from './PlanChoicePanel';

/** Every feature entry compares offers; confirming one enters billing setup. */
export const FeaturePlanChoiceModal = ({
  paywall,
  minimumPlan,
  planLimit,
  onClose,
}: {
  paywall: PaywallType;
  minimumPlan: 'essential' | 'growth' | null;
  planLimit: PlanLimitReachedData | null;
  onClose: () => void;
}) => {
  const { data: billing } = useBillingContextQuery();
  const { openPlans } = usePaywall();
  const targetTier =
    paywall === 'plans'
      ? null
      : upgradeTierFor(
          paywall,
          billing?.effectiveTier ?? planLimit?.currentTier ?? PlanTier.FREE,
          planLimit?.used
        );
  const needsPaidDetails =
    billing?.channel === 'stripe' &&
    (billing.taxQualificationRequired ||
      !billing.billingCurrency ||
      billing.cardSetup.identityRequired ||
      billing.cardSetup.emailVerificationRequired);
  const minimum = minimumPlan ?? (targetTier === PlanTier.GROWTH ? 'growth' : 'essential');
  return (
    <PlanChoicePanel
      context="upgrade"
      initialPlan={minimum}
      minimumPlan={minimum}
      onDecided={onClose}
      {...(needsPaidDetails
        ? {
            onConfirmPaid: (plan: 'essential' | 'growth') =>
              openPlans(plan, { onClose: useUpgradeModalStore.getState().context?.onClose }),
          }
        : {})}
    />
  );
};
